import { FC } from 'react'
import theme from 'theme'

/* Components */
import { PerformanceCategoriesWrapper, PerformanceCategoryItem } from '../../../PerformanceScore/performanceScore.styles'
import WaveSkeleton from './WaveSkeleton'

/* Framework-agnostic placeholder rows so the loading state never shows the wrong
   framework's category names (e.g. Onyxia categories on a NIST/custom environment). */
const rows = [0, 1, 2, 3, 4, 5, 6, 7, 8]

const StubPerformanceCategories: FC = () => (
  <PerformanceCategoriesWrapper className="performance-categories-list-wrapper" sx={{ width: '280px', minWidth: '280px' }}>
    {rows.map((n) => (
      <PerformanceCategoryItem key={n} isselected="false">
        <WaveSkeleton height={16} sx={{ borderRadius: theme.attributes.borderRadius.secondary }} />
      </PerformanceCategoryItem>
    ))}
  </PerformanceCategoriesWrapper>
)

export default StubPerformanceCategories
